import React, { useState } from 'react';
import { Button, Dialog } from '@material-ui/core';
import scenariosStep1 from 'assets/images/scenarios/screenshot-scenarios-step-1.png';
import scenariosStep2 from 'assets/images/scenarios/screenshot-scenarios-step-2.png';

const STEPS = [
  {
    title: 'Introducing Fund-level Scenarios',
    description:
      'Welcome to Diligent Equity’s latest and greatest feature! ' +
      'For a brief tutorial, click “Next” through these pop-ups to learn how you can predict ' +
      'and model your companies’ exits and see how it affects your fund-level metrics.',
    imageURL: scenariosStep1,
  },
  {
    title: 'Company and Fund Actuals',
    description:
      'These areas in the above image display the “Actuals” of your companies and currently selected fund. ' +
      'These are the real-time numbers that currently exist in the Diligent Equity platform, ' +
      'so that you can model scenarios with an understanding of what currently exists.',
    imageURL: scenariosStep2,
  },
  {
    title: 'Building Scenarios',
    description: (
      <span>
        To begin experimenting with Scenarios, navigate to the Fund you want to
        work with, expand a company’s row, and enter the data you would like to
        project.
        <br />
        <span className="mr-2">·</span> Exit Amount: This is a monetary value,
        which equals the Exit Value of the company. This would be how much a
        company liquidated for.
        <br />
        <span className="mr-2">·</span> Exit Date: This is the date that would
        be used for an exit event. It is important for IRR calculations.
      </span>
    ),
    imageURL: '',
  },
  {
    title: 'Saving and Calculating',
    description:
      'The checkboxes to the left of each company indicates if the company-level scenarios ' +
      'will be included in the fund-level scenario calculation at the top of the page. ' +
      'If a checkbox is marked for a company, it will be included; If a checkbox is not marked for a company, ' +
      'it will not be included. This way, you can run company-level scenarios ' +
      'and see results before pushing it to the fund-level scenario!',
    imageURL: '',
  },
  {
    title: 'Enjoy!',
    description:
      'We hope you make use of this new feature and as always, let us know what you think! ' +
      'A more in-depth user manual can be found here.',
    imageURL: '',
  },
];

export const ScenarioOnboardingModal = (props: any) => {
  const { open, onSkip, onClose, onFinish, onNext, className } = props;
  const [step, setStep] = useState(0);
  const handleNext = () => {
    if (step === STEPS.length - 1) {
      onFinish();
    } else {
      setStep(step + 1);
      onNext();
    }
  };
  return (
    <Dialog
      maxWidth="sm"
      className={className}
      open={open}
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}
      onClose={onClose}
    >
      <div>
        <div className="d-flex p-5" style={{ backgroundColor: '#385f99' }}>
          {STEPS[step].imageURL ? (
            <img
              src={STEPS[step].imageURL}
              alt={`step-${step}`}
              className="img-fluid mx-auto"
              style={{ maxWidth: 540, maxHeight: 227 }}
            />
          ) : (
            ''
          )}
        </div>
        <div className="p-4">
          <div className="mb-5">
            <h3 className="text-center mb-3" style={{ fontSize: 27 }}>
              Step {step + 1}. {STEPS[step].title}
            </h3>
            <div className="text-center px-4">
              <span
                className="d-inline-block text-left"
                style={{ fontSize: 16 }}
              >
                {STEPS[step].description}
              </span>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <Button variant="outlined" color="primary" onClick={onSkip}>
              Skip
            </Button>
            <div className="d-flex align-items-center mx-auto">
              {STEPS.map((item, index) => (
                <Button
                  key={`step-button-${index}`}
                  className="mx-3 p-0"
                  onClick={() => {
                    setStep(index);
                    onNext();
                  }}
                  style={{
                    outline: 'none',
                    minWidth: 0,
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: index === step ? '#385f99' : '#d8d8d8',
                  }}
                />
              ))}
            </div>
            <Button variant="contained" color="primary" onClick={handleNext}>
              {step === STEPS.length - 1 ? 'Finish' : 'Next'}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
